import Vue from 'vue'
import Router from 'vue-router'
import PerformanceQuery from '../pages/PerformanceQuery'
import HandOver from '../pages/HandOver'
import ReportForm from '../pages/ReportForm'
import Account from '../pages/Account'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/PerformanceQuery',
      name: 'PerformanceQuery',
      component: PerformanceQuery
    },
    {
      path: '/HandOver',
      name: 'HandOver',
      component: HandOver
    },
    {
      path: '/ReportForm',
      name: 'ReportForm',
      component: ReportForm
    },
    {
      path: '/Account',
      name: 'Account',
      component: Account
    },
    {
      path: '/',
      name: 'PerformanceQuery',
      component: PerformanceQuery
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js